import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const IAOfficersFormEdit = ({ darkMode, toggleDarkMode, onSelect, officer }) => {
  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    middleName: '',
    phoneNumber: '',
    email: '',
    address: '',
    dateOfBirthMonth: '',
    dateOfBirthDay: '',
    dateOfBirthYear: '',
    spouseName: '',
    position: '',
    appointmentYear: '',
    tin: '',
    motto: '',
  });

  useEffect(() => {
    if (officer) {
      setFormData({
        lastName: officer.last_name || '',
        firstName: officer.first_name || '',
        middleName: officer.middle_name || '',
        phoneNumber: officer.phone_number || '',
        email: officer.email || '',
        address: officer.address || '',
        dateOfBirthMonth: officer.date_of_birth ? officer.date_of_birth.split('/')[0] || '' : '',
        dateOfBirthDay: officer.date_of_birth ? officer.date_of_birth.split('/')[1] || '' : '',
        dateOfBirthYear: officer.date_of_birth ? officer.date_of_birth.split('/')[2] || '' : '',
        spouseName: officer.name_of_spouse || '',
        position: officer.position || '',
        appointmentYear: officer.appointment_year || '',
        tin: officer.tin || '',
        motto: officer.motto || '',
      });
    }
  }, [officer]);

  const handleBack = () => {
    console.log('Closing IAOfficersFormEdit');
    if (typeof onSelect === 'function') {
      onSelect('IAOfficers', { closeForm: true });
    } else {
      console.warn('onSelect is not a function. Failed to close IAOfficersFormEdit.');
    }
  };

  const handleSave = () => {
    console.log('Save clicked', formData); // Non-functional for now
  };

  return (
    <PageContainer darkMode={darkMode}>
      <PageContent darkMode={darkMode}>
        <PageHeader>
          <PageTitle>IA Profiling Edit</PageTitle>
          <CloseButton onClick={handleBack} darkMode={darkMode} title="Close">
            ×
          </CloseButton>
        </PageHeader>
        <PersonalInfo>Personal Information</PersonalInfo>
        <FormGroup>
          <Label>Full Name:</Label>
          <InputGroup>
            <Input value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} placeholder="Last Name" darkMode={darkMode} />
            <Input value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} placeholder="First Name" darkMode={darkMode} />
            <Input value={formData.middleName} onChange={(e) => setFormData({ ...formData, middleName: e.target.value })} placeholder="Middle Name" darkMode={darkMode} />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>Contact:</Label>
          <InputGroup>
            <Input value={formData.phoneNumber} onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })} placeholder="Phone Number" darkMode={darkMode} />
            <Input value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} placeholder="Email" darkMode={darkMode} />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>Address:</Label>
          <Input value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} placeholder="Street, Brgy, Municipality, Province, Country" darkMode={darkMode} />
        </FormGroup>
        <FormGroup>
          <Label>Date of Birth:</Label>
          <InputGroup>
            <Input value={formData.dateOfBirthMonth} onChange={(e) => setFormData({ ...formData, dateOfBirthMonth: e.target.value })} placeholder="Month" darkMode={darkMode} />
            <Input value={formData.dateOfBirthDay} onChange={(e) => setFormData({ ...formData, dateOfBirthDay: e.target.value })} placeholder="Day" darkMode={darkMode} />
            <Input value={formData.dateOfBirthYear} onChange={(e) => setFormData({ ...formData, dateOfBirthYear: e.target.value })} placeholder="Year" darkMode={darkMode} />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>Name of Spouse:</Label>
          <Input value={formData.spouseName} onChange={(e) => setFormData({ ...formData, spouseName: e.target.value })} placeholder="Full Name" darkMode={darkMode} />
        </FormGroup>
        <FormGroup>
          <Label>Position:</Label>
          <InputGroup>
            <Input value={formData.position} onChange={(e) => setFormData({ ...formData, position: e.target.value })} placeholder="Position" darkMode={darkMode} />
            <Input value={formData.appointmentYear} onChange={(e) => setFormData({ ...formData, appointmentYear: e.target.value })} placeholder="Appointment Year" darkMode={darkMode} />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>TIN:</Label>
          <Input value={formData.tin} onChange={(e) => setFormData({ ...formData, tin: e.target.value })} placeholder="************" darkMode={darkMode} />
        </FormGroup>
        <FormGroup>
          <Label>Motto:</Label>
          <Textarea value={formData.motto} onChange={(e) => setFormData({ ...formData, motto: e.target.value })} placeholder="A Boss will say 'Go!' A Leader will say 'Let's go!'" darkMode={darkMode} />
        </FormGroup>
        <SaveButton onClick={handleSave}>Save</SaveButton>
      </PageContent>
    </PageContainer>
  );
};

export default IAOfficersFormEdit;

const PageContainer = styled.div`
  padding: 20px 40px 20px 20px;
  background-color: ${props => (props.darkMode ? '#1a1a1a' : '#ffffff')};
  height: 100%;
  box-sizing: border-box;
  color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
  overflow: auto;
`;

const PageContent = styled.div`
  max-width: 800px;
  margin: 0;
  padding: 23px;
  background-color: ${props => (props.darkMode ? '#333333' : '#f0f0f0')};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2e7d32;
  color: #ffffff;
  padding: 10px 20px;
  margin: -20px -20px 20px -20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 4px;
`;

const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background-color: ${props => (props.darkMode ? '#555555' : '#ffffff')};
  color: ${props => (props.darkMode ? '#ffffff' : '#2e7d32')};
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  padding: 0;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${props => (props.darkMode ? '#777777' : '#e0e0e0')};
  }
`;

const PersonalInfo = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  font-weight: normal;
  margin-bottom: 5px;
`;

const InputGroup = styled.div`
  display: grid;
  gap: 10px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #333;
  border-radius: 4px;
  flex: 1;
  background-color: ${props => (props.darkMode ? '#333333' : '#ffffff')};
  color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  min-height: 60px;
  background-color: ${props => (props.darkMode ? '#333333' : '#ffffff')};
  color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
`;

const SaveButton = styled.button`
  padding: 10px 20px;
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  &:hover {
    background-color: #1b5e20;
  }
`;